import React from 'react';

const Loading = ({ label = 'Retrieving records' }: { label?: string }) => (
   <div className="flex flex-col items-center justify-center gap-5 py-24 text-center" role="status">
      <div className="relative h-12 w-12">
         <span className="absolute inset-0 animate-spin rounded-full border border-white/10 border-t-signal" />
         <span className="absolute inset-[38%] rounded-full bg-signal animate-pulseDot" />
      </div>
      <span className="eyebrow">{label}…</span>
   </div>
);

export default Loading;
